"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _analytics = require("../../common/analytics");

require("./AccessibeLink.scss");

var _React$Fragment;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function importAccessibe() {
  return new Promise(function (resolve) {
    var script = document.createElement('script');
    script.onload = resolve;
    script.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
    script.async = true;
    document.body.appendChild(script);
  });
}

function initializeAccessibe() {
  // Exit if accessibe was already initialized
  if (window.acsbJS) {
    return;
  }

  importAccessibe().then(function () {
    window.acsbJS.init({
      statementLink: '',
      footerHtml: 'Web Accessibility Settings',
      hideMobile: false,
      hideTrigger: false,
      language: 'en',
      position: 'left',
      leadColor: '#282827',
      triggerColor: '#fc5647',
      triggerRadius: '50%',
      triggerPositionX: 'left',
      triggerPositionY: 'bottom',
      triggerIcon: 'people',
      triggerSize: 'medium',
      triggerOffsetX: 20,
      triggerOffsetY: 20,
      mobile: {
        triggerSize: 'small',
        triggerPositionX: 'left',
        triggerPositionY: 'bottom',
        triggerOffsetX: 20,
        triggerOffsetY: 20,
        triggerRadius: '50%'
      }
    });
  });
}

function AccessibeLink(_ref) {
  var _ref$description = _ref.description,
      description = _ref$description === void 0 ? 'Accessibe Clicked' : _ref$description,
      userId = _ref.userId,
      _ref$activityLocation = _ref.activityLocation,
      activityLocation = _ref$activityLocation === void 0 ? 'Footer' : _ref$activityLocation,
      _ref$prependPipe = _ref.prependPipe,
      prependPipe = _ref$prependPipe === void 0 ? false : _ref$prependPipe,
      _ref$strongStyle = _ref.strongStyle,
      strongStyle = _ref$strongStyle === void 0 ? false : _ref$strongStyle;
  var accessibeKey = 'do_load_accesibe_js';

  if (typeof window !== 'undefined' && window.localStorage.getItem(accessibeKey) === 'yes') {
    initializeAccessibe();
  }

  var activatePollingToOpenAccessibe = function activatePollingToOpenAccessibe() {
    // wait for it to appear and click it
    var checkExist = window.setInterval(function () {
      var elExists = document.querySelector('.acsb-trigger');

      if (elExists) {
        elExists.click();
        window.clearInterval(checkExist);
      }
    }, 100);
  };

  function enableAccessibe(e) {
    _analytics.tracker.track('Item Clicked', {
      activityLocation: activityLocation,
      description: description,
      userId: userId
    });

    window.localStorage.setItem(accessibeKey, 'yes');
    initializeAccessibe();
    activatePollingToOpenAccessibe();
  }

  return /*#__PURE__*/(0, _jsx2.default)("span", {
    id: "accessibe-footer-container"
  }, void 0, prependPipe && (_React$Fragment || (_React$Fragment = /*#__PURE__*/(0, _jsx2.default)(_react.default.Fragment, {}, void 0, "\xA0|\xA0"))), /*#__PURE__*/(0, _jsx2.default)("button", {
    id: "accessibe-footer-link",
    className: strongStyle ? 'accessibe-strong' : undefined,
    onClick: enableAccessibe,
    type: "button"
  }, void 0, "Accessibility Tools"));
}

var _default = AccessibeLink;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/footer/AccessibeLink.js
// module id = 3647
// module chunks = 25